import React from "react";

export default function EmojiSettings({ game }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-black text-white flex flex-col">
      <div className="sticky top-0 z-30 bg-slate-950/90 backdrop-blur border-b border-cyan-500/20">
        <div className="flex items-center justify-between px-2 py-2">
          <button
            onClick={() => game.setScreen("home")}
            className="w-fit px-2 py-2 text-sm lg:text-lg text-cyan-300"
          >
            ← Back
          </button>

          <div className="text-xl font-black text-cyan-300">
            ⚙️ Emoji Settings
          </div>

          <div className="w-8" />
        </div>
      </div>

      <div className="px-3 mt-5">
        <div className="text-sm font-bold text-slate-300 mb-2">Grid Size</div>
        <div className="grid grid-cols-4 gap-2">
          {[1, 2, 3, 4].map((size) => (
            <button
              key={size}
              onClick={() => game.setGridSize(size)}
              className={`
                py-2 rounded-xl text-sm lg:text-lg font-bold transition
                ${
                  game.gridSize === size
                    ? "bg-blue-500 text-white"
                    : "bg-slate-800"
                }
              `}
            >
              🟦 {size}×{size}
            </button>
          ))}
        </div>
      </div>

      <div className="px-2 mt-2">
        <div className="text-sm lg:text-sm font-bold text-slate-300 mb-2">Category</div>
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-2">
          {[
            { key: "faces", emoji: "😀", label: "Faces" },
            { key: "animals", emoji: "🦁", label: "Animals" },
            { key: "food", emoji: "🍕", label: "Food" },
            { key: "nature", emoji: "🌳", label: "Nature" },
            { key: "objects", emoji: "🎁", label: "Objects" },
            { key: "mixed", emoji: "🎲", label: "Random" },
          ].map((cat) => (
            <button
              key={cat.key}
              onClick={() => game.setCategory(cat.key)}
              className={`
                py-1 rounded-xl text-sm lg:text-lg font-bold transition
                ${
                  game.category === cat.key
                    ? "bg-pink-500 text-white"
                    : "bg-slate-800"
                }
              `}
            >
              {cat.emoji} {cat.label}
            </button>
          ))}
        </div>
      </div>

      <div className="px-3 mt-6">
        <div className="text-sm font-bold text-slate-300 mb-2">Speed</div>
        <div className="grid grid-cols-3 gap-2">
          {["slow", "medium", "fast"].map((speed) => (
            <button
              key={speed}
              onClick={() => game.setSpeed(speed)}
              className={`
                  py-2 rounded-xl font-black transition capitalize
                  ${game.speed === speed ? "bg-emerald-500 text-black" : "bg-slate-800"}
                  `}
            >
              ⚡ {speed}
            </button>
          ))}
        </div>
      </div>

      <div className="px-3 mt-8">
        <div className="rounded-2xl bg-slate-900 border border-slate-800 p-4">
          <div className="text-cyan-300 font-black">🎯 Tip for Parents</div>
          <div className="text-sm text-slate-400 mt-2">
            Smaller grids + slow speed = learning mode
            <br />
            Bigger grids + fast speed = challenge mode
          </div>
        </div>
      </div>

      <div className="px-3 mt-10 mb-10">
        <button
          onClick={() => game.setScreen("home")}
          className="w-fit px-4 py-2 rounded-xl bg-cyan-500 text-black font-black text-lg active:scale-95 transition"
        >
          ✅ Save & Go Home
        </button>
      </div>
    </div>
  );
}